const setTeaserCardHeight = (widget = null) => {

  let cards;

  if (widget) {
    cards = document.querySelectorAll(`${widget} .c-card--teaser`)
  } else {
    cards = document.querySelectorAll('.c-card--teaser')
  }

  cards.forEach (card => {
    if (card.classList.contains('c-card--teaser--large')) {
      if(card.closest('[data-widget_type="swe_teaser_card.default"]')) {
        card.closest('[data-widget_type="swe_teaser_card.default"]').classList.add('swe_teaser_card--large');
      }
    }
  });
}

setTeaserCardHeight();
window.setTeaserCardHeight = setTeaserCardHeight
